<template>
  <div id="navbar-wrapper">
    <div id="navbar">
      <flickity class="carousel" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell" data-href="/libros/autoras"><img alt="La femme de la femme" src="../assets/cartelas/femme.png"></div>
        <div class="carousel-cell" data-href="/libros/criminal"><img alt="Delitos sin faltas" src="../assets/cartelas/delitos.png"></div>
        <div class="carousel-cell" data-href="/libros/ilustrado"><img alt="Cariátide" src="../assets/cartelas/cariatide.png"></div>
        <div class="carousel-cell" data-href="/libros/infantilyjuvenil"><img alt="Infantil Juvenil" src="../assets/cartelas/infantil-juvenil.png"></div>
        <div class="carousel-cell" data-href="/libros/otros"><img alt="Sui generis" src="../assets/cartelas/sui-generis.png"></div>
        <div class="carousel-cell" data-href="/articulos"><img alt="La signora Cronopio" src="../assets/cartelas/cronopio.png"></div>
      </flickity>
    </div>
  </div>
    <!-- <div id="nav">
      <router-link :to="{ name: 'Home'}">Inicio</router-link> |
      <router-link :to="{ name: 'Guide'}">Hoja de sala</router-link> |
      <router-link :to="{ name: 'Books', params: { category: 'criminal'}}">Criminal</router-link> |
      <router-link :to="{ name: 'Books', params: { category: 'autoras'}}">Autoras</router-link> |
      <router-link :to="{ name: 'Books', params: { category: 'ilustrado'}}">Ilustrado</router-link> |
      <router-link :to="{ name: 'Books', params: { category: 'otros'}}">Otros</router-link> |
      <router-link :to="{ name: 'Articles'}">Art&iacute;culos</router-link> |
      <router-link id="foo" :to="{ name: 'Articles'}"> </router-link>
    </div> -->
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'Navbar',
  components: {
    Flickity
  },
  data () {
    return {
      flickityOptions: {
        cellSelector: '.carousel-cell',
        cellAlign: 'center',
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        imagesLoaded: true,
        setGallerySize: false
      }
    }
  },
  mounted () {
    this.updateCurrentSlide()
    this.slideEventListener()
  },
  methods: {
    updateCurrentSlide () {
      var currentRoute = window.location.pathname
      console.log('Current route: ' + currentRoute)
      var children = document.querySelector('.flickity-slider').children
      for (var i = 0; i < children.length; i++) {
        var slideRoute = children[i].dataset.href
        if (slideRoute === currentRoute) {
          var carousel = this.$refs.flickity.data(document.querySelector('.carousel'))
          var isWrapped = true
          var isInstant = true
          carousel.select(i, isWrapped, isInstant)
        }
      }
    },
    slideEventListener () {
      this.$refs.flickity.on('change', (i) => {
        var carousel = this.$refs.flickity.data(document.querySelector('.carousel'))
        var route = carousel.selectedElement.dataset.href
        console.log('Changed to slide ' + i + ' : ' + route)
        const query = {}
        query.cuadro = i
        this.$router.push({ path: '/exposicion', query: query })
      })

      this.$refs.flickity.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        const query = {}
        query.cuadro = cellIndex
        this.$router.push({ path: '/exposicion', query: query })
      })
    }
  }
}
</script>

<style scoped lang="scss">

$debug: false;

#navbar-wrapper {
  @if $debug == true {
    border: solid 1px #0000FF;
    background-color: beige;
  }

  height: 5vh;
  width: 100%;
  padding-top: 2.0em;
  padding-bottom: 4.0em;
  // margin-bottom: 0.1em;

  @include respond-above(sm) {
    padding-top: 2.0em;
  }

  @include respond-below(sm) {
    padding-top: 0.0em;
  }
}

#navbar {
  @if $debug == true {
    border: solid 1px #00FF00;
  }

  // display: flex;
  // justify-content: center;

  margin: auto;
  padding: 0px;
  height: 72px;
  // width: 450px;

  a {
    font-size: 1.2em;
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;

    &.router-link-exact-active {
      color: #631c2c;
    }
  }

  a:hover {
    color: #631c2c;
  }
}

#foo {
  color: #900;
}
@include respond-above(xs) { #foo::after { content: "XS"; } }
@include respond-above(sm) { #foo::after { content: "SM"; } }
@include respond-above(md) { #foo::after { content: "MD"; } }
@include respond-above(lg) { #foo::after { content: "LG"; } }

.carousel { height: 100%; }

.carousel-cell {
  width: 80%; /* full width */
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0px 0px 6px #666666);
  // /* background: #222; */
  // /* center images in cells with flexbox */
  // display: flex;
  // align-items: center;
  // justify-content: center;
}

.carousel-cell img {
  display: block;
  max-height: 100%;
  margin: 0 auto;
  max-width: 100%;
  opacity: 1;
}

</style>
